import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Loading } from '../components/shared/Loading';
import useLoginByGivenToken from '../hooks/useLoginByGivenToken';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAllowedCountries } from '../hooks/useRoutes';
import { setMessage } from '../redux/actions/message';
import { routes } from '../constants/routes';
import { appsOrigin } from '../constants/appOrigin';

/**
 * Login with token
 * @returns {JSX}
 */
const LoginBifrostPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { allowed } = useAllowedCountries()
  
  const [loginToken, setLoginToken] = React.useState(null);
  useLoginByGivenToken({token: loginToken});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Detect location
  useEffect(() => {
    if (!allowed) {
      dispatch(setMessage(t("common.countryNotAllowed"), 'error'));
      return navigate(routes.login(appsOrigin.default));
    }
  }, [loginToken])

  // Getting token from autologin
  useEffect(() => {
    if(!loginToken){
      const token = searchParams.get('token');
      if (!token) {
        dispatch(setMessage(t("message.errorToken"), 'error'));
        return navigate(routes.login(appsOrigin.default));
      } else {
        setLoginToken(token);
      }
  
    }
  }, []);



  return (
    <Loading />
  );
};

export default LoginBifrostPage;